<template>
  <el-table-column
    prop="is_stockist"
    sortable="custom"
    label="Besz. ár végleges"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.is_stockist" size="small" type="success">Igen</el-tag>
      <el-tag v-if="!scope.row.is_stockist" size="small" type="danger">Nem</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'is_stockist',
};
</script>
